<script>
import { Bar } from 'vue-chartjs';

export default {
  extends: Bar,
  name: 'chart',
  props: ['datasets', 'barOptions'],
  mounted() {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(
      this.datasets,
      this.barOptions
    );
    const generatedHtml = this.$data._chart.generateLegend()
    this.$emit('generated', generatedHtml)
  }
};
</script>


// WEBPACK FOOTER //
// src/components/commons/charts/Chart.vue